// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.practice-exam-analysis-nav {
  position: relative;
  background: #077EE6;
}
.practice-exam-analysis-nav .header-top {
  position: relative;
  box-shadow: none;
  z-index: 2;
}
.practice-exam-analysis-nav .header-top .navbar-nav {
  align-items: center;
}
.practice-exam-analysis-nav .header-top .navbar-nav .nav-link {
  color: #ffffff;
}
.practice-exam-analysis-nav .header-top .navbar-nav .profile-img {
  background: rgba(255, 255, 255, 0.1647058824);
  border: 1px solid #84b9e2;
  border-radius: 21px;
}
.practice-exam-analysis-nav .header-top .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.practice-exam-analysis-nav .header-top .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.practice-exam-analysis-nav .header-top .search .search-bar {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.0901960784);
  box-shadow: none;
}
.practice-exam-analysis-nav .header-top .student-notification i {
  font-size: 1.5rem;
}
.practice-exam-analysis-nav .header-bottom {
  position: relative;
  z-index: 1;
}
.practice-exam-analysis-nav .header-bottom .list-inline li {
  margin-right: 35px;
  position: relative;
}
.practice-exam-analysis-nav .header-bottom .list-inline li::before {
  right: -25px;
  bottom: 3px;
  position: absolute;
  color: #ffffff;
  content: "\\f30b";
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
.practice-exam-analysis-nav .header-bottom .list-inline li:last-child {
  margin-right: 0;
}
.practice-exam-analysis-nav .header-bottom .list-inline li:last-child::before {
  display: none;
}
.practice-exam-analysis-nav .header-bottom .card {
  border-radius: 10px;
  background-color: hsla(0, 0%, 100%, 0.46);
}
.practice-exam-analysis-nav .header-bottom .card img {
  margin-top: -3rem;
  margin-bottom: 10px;
}
.practice-exam-analysis-nav .header-bottom .datePicker .calendar {
  color: #ffffff;
  position: absolute;
  left: 15px;
  top: 0;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.4588235294);
  padding: 10px;
  border-radius: 4px;
}
.practice-exam-analysis-nav .header-bottom .datePicker .form-control {
  padding-left: 40px;
  background-color: hsla(0, 0%, 100%, 0.46);
  color: #ffffff;
}
.practice-exam-analysis-nav .header-bottom .datePicker .form-control::placeholder {
  color: #ffffff;
}
.practice-exam-analysis-nav .header-bottom .datePicker .rdtPicker {
  right: 0;
}

.practice-exam-analysis .filter button {
  padding: 0.45rem 1rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1019607843);
}
.practice-exam-analysis .totalPractice {
  position: relative;
  border-radius: 6px;
  background: #D8D8D8;
}
.practice-exam-analysis .totalPractice .card-header {
  border-radius: 6px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid #EEEEEE;
}
.practice-exam-analysis .totalPractice .card-header .content .accuracy {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  background: #D8E1E9;
  border-radius: 0px 6px;
}
.practice-exam-analysis .totalPractice .card-header .content .student-img {
  position: relative;
  margin-top: -3.2rem;
}
.practice-exam-analysis .totalPractice .card-header .appaired {
  border: none;
  background: #EEEEEE;
}
.practice-exam-analysis .totalPractice .card-header .status-list .list-inline-item {
  padding: 0.45rem;
  border-right: 1px solid #dee2e6;
}
.practice-exam-analysis .totalPractice .card-header .status-list .list-inline-item p.title {
  font-size: 13px;
  line-height: 14px !important;
  height: 27px;
}
.practice-exam-analysis .totalPractice .card-header .status-list .list-inline-item:last-child {
  border-right: 0;
}
.practice-exam-analysis .totalPractice .card-body {
  overflow: hidden;
}
.practice-exam-analysis .totalPractice .card-body .totalPractice-tabs {
  background: #F2F5F8;
  border: 1px solid #D8D8D8;
  border-radius: 6px;
}
.practice-exam-analysis .totalPractice .card-body .totalPractice-tabs .nav-pills .nav-item .nav-link {
  color: #A2A2B1;
  border-radius: 0.25rem;
  padding: 0.25rem 0.75rem;
  transition: ease-in all 0.2s;
}
.practice-exam-analysis .totalPractice .card-body .totalPractice-tabs .nav-pills .nav-item .nav-link.active, .practice-exam-analysis .totalPractice .card-body .totalPractice-tabs .nav-pills .nav-item .nav-link:hover {
  border-radius: 30px;
  color: #fff;
  background-color: #007bff;
}
.practice-exam-analysis .totalPractice .card-body .totalPractice-tabs .btn-lightblue {
  border-radius: 6px;
  font-size: 13px;
  padding: 0.45rem 0.75rem;
}
.practice-exam-analysis .totalPractice .card-body .totalPractice-tabs .tab-content .single-card .title span {
  color: #00c596;
}
.practice-exam-analysis .totalPractice .card-body .totalPractice-tabs .tab-content .single-card .card {
  padding: 0.45rem;
  background: #D8D8D8;
  border-radius: 4px;
  margin: 4px 0;
  border: none;
}
.practice-exam-analysis .totalExams {
  position: relative;
  border-radius: 6px;
  background: #D8D8D8;
}
.practice-exam-analysis .totalExams .card-header {
  border-radius: 6px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid #EEEEEE;
}
.practice-exam-analysis .totalExams .card-header .content .accuracy {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  background: #D8E1E9;
  border-radius: 0px 6px;
}
.practice-exam-analysis .totalExams .card-header .content .student-img {
  position: relative;
  margin-top: -8rem;
}
.practice-exam-analysis .totalExams .card-header .appaired {
  border: none;
  background: #EEEEEE;
}
.practice-exam-analysis .totalExams .card-header .totalExam-list li {
  width: 59px;
  height: 50px;
  padding: 3px;
  text-align: center;
  background: #DFE9F3;
  border-radius: 4px;
  display: inline-block;
  margin-right: 10px;
}
.practice-exam-analysis .totalExams .card-header .totalExam-list li:last-child {
  margin-right: 0;
}
.practice-exam-analysis .totalExams .card-header .totalExam-list li h6 {
  font-size: 12px;
}
.practice-exam-analysis .totalExams .card-header .totalExam-list li p {
  font-size: 10px;
}
.practice-exam-analysis .totalExams .card-header .status-list .list-inline-item {
  padding: 0.45rem;
  border-right: 1px solid #dee2e6;
}
.practice-exam-analysis .totalExams .card-header .status-list .list-inline-item p.title {
  font-size: 13px;
  line-height: 14px !important;
  height: 27px;
}
.practice-exam-analysis .totalExams .card-header .status-list .list-inline-item:last-child {
  border-right: 0;
}
.practice-exam-analysis .totalExams .card-body {
  overflow: hidden;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs {
  background: #ffffff;
  border: 1px solid #D8D8D8;
  border-radius: 6px;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .nav-pills .nav-item .nav-link {
  color: #A2A2B1;
  border-radius: 0.25rem;
  padding: 0.25rem 0.75rem;
  transition: ease-in all 0.2s;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .nav-pills .nav-item .nav-link.active, .practice-exam-analysis .totalExams .card-body .totalExams-tabs .nav-pills .nav-item .nav-link:hover {
  border-radius: 30px;
  color: #fff;
  background-color: #FEAF55;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .btn-lightblue {
  border-radius: 6px;
  font-size: 13px;
  padding: 0.45rem 0.75rem;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .tab-content .table thead {
  border-bottom: 1px solid #D8D8D8;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .tab-content .table tbody td {
  padding: 5px 6px;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .tab-content .table tbody tr:nth-child(1) td {
  color: #00C596;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .tab-content .table tbody tr:nth-child(5) td {
  color: #f50049;
}
.practice-exam-analysis .totalExams .card-body .totalExams-tabs .tab-content .table .btn-lightblue {
  border-radius: 25px;
  font-size: 13px;
  padding: 0.25rem 0.75rem;
  margin-bottom: 0;
}
.practice-exam-analysis .conduct-exams .table thead th {
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
}
.practice-exam-analysis .conduct-exams .table thead th .types p {
  font-weight: 400;
  padding: 6px;
  color: #ced4da;
}
.practice-exam-analysis .conduct-exams .table thead th .types p:nth-child(1) {
  text-align: right;
}
.practice-exam-analysis .conduct-exams .table thead th .types hr {
  margin: 0;
  transform: rotate(20deg);
}
.practice-exam-analysis .conduct-exams .table thead th:first-child {
  padding: 0;
  text-align: left;
}
.practice-exam-analysis .conduct-exams .table thead th:first-child,
.practice-exam-analysis .conduct-exams .table tbody td:first-child {
  border-right: 1px solid #D8D8D8;
}
.practice-exam-analysis .conduct-exams .table tbody td {
  text-align: center;
  vertical-align: middle;
  padding: 1rem 0.65rem;
}
.practice-exam-analysis .conduct-exams .table tbody td .count span {
  color: #F05D70;
  position: relative;
  width: 25px;
  height: 25px;
  font-size: 12px;
  text-align: center;
}
.practice-exam-analysis .conduct-exams .table tbody td .count span::before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  border: 1px solid #F05D70;
  border-radius: 50%;
  left: -6px;
  top: -4px;
}
.practice-exam-analysis .conduct-exams .table tbody td i {
  color: #00C596;
  font-size: 1.4rem;
}
.practice-exam-analysis .conduct-exams .table tbody tr td:first-child {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/neetjee_guru/components/analysis/practice_exam_analysis/_practiceexamanalysis.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AA7WA;EACI,kBAAA;EACA,mBAAA;AAgXJ;AA9WI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AAgXR;AA9WQ;EACI,mBAAA;AAgXZ;AA9WY;EACI,cAAA;AAgXhB;AA7WY;EACI,6CAAA;EACA,yBAAA;EACA,mBAAA;AA+WhB;AA7WgB;EACI,WAAA;EACA,YAAA;AA+WpB;AA3WoB;EACI,eAAA;EACA,gBAAA;AA6WxB;AAvWQ;EACI,cAAA;EACA,6CAAA;EACA,gBAAA;AAyWZ;AAtWQ;EACI,iBAAA;AAwWZ;AApWI;EACI,kBAAA;EACA,UAAA;AAsWR;AApWQ;EACI,kBAAA;EACA,kBAAA;AAsWZ;AApWY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AAsWhB;AAnWY;EACI,eAAA;AAqWhB;AAnWgB;EACI,aAAA;AAqWpB;AAhWQ;EACI,mBAAA;EACA,yCAAA;AAkWZ;AAhWY;EACI,iBAAA;EACA,mBAAA;AAkWhB;AA7VY;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;AA+VhB;AA5VY;EACI,kBAAA;EACA,yCAAA;EACA,cAAA;AA8VhB;AA5VgB;EACI,cAAA;AA8VpB;AA1VY;EACI,QAAA;AA4VhB;;AApVQ;EACI,qBAAA;EACA,oDAAA;AAuVZ;AAnVI;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;AAqVR;AAnVQ;EACI,kBAAA;EACA,oDAAA;EACA,yBAAA;AAqVZ;AAlVgB;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAoVpB;AAjVgB;EACI,kBAAA;EACA,mBAAA;AAmVpB;AA/UY;EACI,YAAA;EACA,mBAAA;AAiVhB;AA9UY;EACI,gBAAA;EACA,+BAAA;AAgVhB;AA9UgB;EACI,eAAA;EACA,4BAAA;EACA,YAAA;AAgVpB;AA7UgB;EACI,eAAA;AA+UpB;AA1UQ;EACI,gBAAA;AA4UZ;AA1UY;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;AA4UhB;AA1UgB;EACI,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;AA4UpB;AA1UoB;EAEI,mBAAA;EACA,WAAA;EACA,yBAAA;AA2UxB;AAvUgB;EACI,kBAAA;EACA,eAAA;EACA,wBAAA;AAyUpB;AApUwB;EACI,cAAA;AAsU5B;AAnUwB;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAqU5B;AA7TI;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;AA+TR;AA7TQ;EACI,kBAAA;EACA,oDAAA;EACA,yBAAA;AA+TZ;AA5TgB;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AA8TpB;AA3TgB;EACI,kBAAA;EACA,iBAAA;AA6TpB;AAzTY;EACI,YAAA;EACA,mBAAA;AA2ThB;AAxTY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AA0ThB;AAxTgB;EACI,eAAA;AA0TpB;AAvTgB;EACI,eAAA;AAyTpB;AAtTgB;EACI,eAAA;AAwTpB;AApTY;EACI,gBAAA;EACA,+BAAA;AAsThB;AApTgB;EACI,eAAA;EACA,4BAAA;EACA,YAAA;AAsTpB;AAnTgB;EACI,eAAA;AAqTpB;AAhTQ;EACI,gBAAA;AAkTZ;AAhTY;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;AAkThB;AAhTgB;EACI,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;AAkTpB;AAhToB;EAEI,mBAAA;EACA,WAAA;EACA,yBAAA;AAiTxB;AA7SgB;EACI,kBAAA;EACA,eAAA;EACA,wBAAA;AA+SpB;AA1SwB;EACI,gCAAA;AA4S5B;AAzSwB;EACI,gBAAA;AA2S5B;AAxSwB;EACI,cAAA;AA0S5B;AAvSwB;EACI,cAAA;AAyS5B;AAtSwB;EACI,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;AAwS5B;AA9RY;EACI,kBAAA;EACA,sBAAA;EACA,gCAAA;AAgShB;AA7RoB;EACI,gBAAA;EACA,YAAA;EACA,cAAA;AA+RxB;AA5RoB;EACI,iBAAA;AA8RxB;AA3RoB;EACI,SAAA;EACA,wBAAA;AA6RxB;AAxRY;EACI,UAAA;EACA,gBAAA;AA0RhB;AAvRY;;EAEI,+BAAA;AAyRhB;AAtRY;EACI,kBAAA;EACA,sBAAA;EACA,qBAAA;AAwRhB;AArRoB;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAuRxB;AArRwB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAuR5B;AAlRgB;EACI,cAAA;EACA,iBAAA;AAoRpB;AAhRY;EACI,kBAAA;AAkRhB","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import '../../../../_config.scss';\n\n\n.practice-exam-analysis-nav {\n    position: relative;\n    background: #077EE6;\n\n    .header-top {\n        position: relative;\n        box-shadow: none;\n        z-index: 2;\n\n        .navbar-nav {\n            align-items: center;\n\n            .nav-link {\n                color: #ffffff;\n            }\n\n            .profile-img {\n                background: #ffffff2a;\n                border: 1px solid #84b9e2;\n                border-radius: 21px;\n\n                img {\n                    width: 35px;\n                    height: 35px;\n                }\n\n                .text {\n                    .profile-name {\n                        font-size: 14px;\n                        line-height: 6px;\n                    }\n                }\n            }\n        }\n\n        .search .search-bar {\n            color: #ffffff;\n            background: #ffffff17;\n            box-shadow: none;\n        }\n\n        .student-notification i {\n            font-size: 1.5rem;\n        }\n    }\n\n    .header-bottom {\n        position: relative;\n        z-index: 1;\n\n        .list-inline li {\n            margin-right: 35px;\n            position: relative;\n\n            &::before {\n                right: -25px;\n                bottom: 3px;\n                position: absolute;\n                color: #ffffff;\n                content: \"\\f30b\";\n                font-family: \"Font Awesome 5 Pro\";\n                font-weight: 900;\n                display: inline-block;\n                font-style: normal;\n                font-variant: normal;\n                text-rendering: auto;\n                line-height: 1;\n            }\n\n            &:last-child {\n                margin-right: 0;\n\n                &::before {\n                    display: none;\n                }\n            }\n        }\n\n        .card {\n            border-radius: 10px;\n            background-color: hsla(0, 0%, 100%, 0.46);\n\n            img {\n                margin-top: -3rem;\n                margin-bottom: 10px;\n            }\n        }\n\n        .datePicker {\n            .calendar {\n                color: #ffffff;\n                position: absolute;\n                left: 15px;\n                top: 0;\n                font-size: 18px;\n                background: #ffffff75;\n                padding: 10px;\n                border-radius: 4px;\n            }\n\n            .form-control {\n                padding-left: 40px;\n                background-color: hsla(0, 0%, 100%, 0.46);\n                color: #ffffff;\n\n                &::placeholder {\n                    color: #ffffff;\n                }\n            }\n\n            .rdtPicker {\n                right: 0;\n            }\n        }\n    }\n}\n\n.practice-exam-analysis {\n    .filter {\n        button {\n            padding: 0.45rem 1rem;\n            box-shadow: 0px 0px 10px #0000001A;\n        }\n    }\n\n    .totalPractice {\n        position: relative;\n        border-radius: 6px;\n        background: #D8D8D8;\n\n        .card-header {\n            border-radius: 6px;\n            box-shadow: 0px 0px 20px #00000029;\n            border: 1px solid #EEEEEE;\n\n            .content {\n                .accuracy {\n                    position: absolute;\n                    right: 0;\n                    top: 0;\n                    padding: 10px;\n                    background: #D8E1E9;\n                    border-radius: 0px 6px;\n                }\n\n                .student-img {\n                    position: relative;\n                    margin-top: -3.2rem;\n                }\n            }\n\n            .appaired {\n                border: none;\n                background: #EEEEEE\n            }\n\n            .status-list .list-inline-item {\n                padding: 0.45rem;\n                border-right: 1px solid #dee2e6;\n\n                p.title {\n                    font-size: 13px;\n                    line-height: 14px !important;\n                    height: 27px;\n                }\n\n                &:last-child {\n                    border-right: 0;\n                }\n            }\n        }\n\n        .card-body {\n            overflow: hidden;\n\n            .totalPractice-tabs {\n                background: #F2F5F8;\n                border: 1px solid #D8D8D8;\n                border-radius: 6px;\n\n                .nav-pills .nav-item .nav-link {\n                    color: #A2A2B1;\n                    border-radius: 0.25rem;\n                    padding: 0.25rem 0.75rem;\n                    transition: ease-in all 0.2s;\n\n                    &.active,\n                    &:hover {\n                        border-radius: 30px;\n                        color: #fff;\n                        background-color: #007bff;\n                    }\n                }\n\n                .btn-lightblue {\n                    border-radius: 6px;\n                    font-size: 13px;\n                    padding: 0.45rem 0.75rem;\n                }\n\n                .tab-content {\n                    .single-card {\n                        .title span {\n                            color: #00c596;\n                        }\n\n                        .card {\n                            padding: 0.45rem;\n                            background: #D8D8D8;\n                            border-radius: 4px;\n                            margin: 4px 0;\n                            border: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .totalExams {\n        position: relative;\n        border-radius: 6px;\n        background: #D8D8D8;\n\n        .card-header {\n            border-radius: 6px;\n            box-shadow: 0px 0px 20px #00000029;\n            border: 1px solid #EEEEEE;\n\n            .content {\n                .accuracy {\n                    position: absolute;\n                    right: 0;\n                    top: 0;\n                    padding: 10px;\n                    background: #D8E1E9;\n                    border-radius: 0px 6px;\n                }\n\n                .student-img {\n                    position: relative;\n                    margin-top: -8rem;\n                }\n            }\n\n            .appaired {\n                border: none;\n                background: #EEEEEE\n            }\n\n            .totalExam-list li {\n                width: 59px;\n                height: 50px;\n                padding: 3px;\n                text-align: center;\n                background: #DFE9F3;\n                border-radius: 4px;\n                display: inline-block;\n                margin-right: 10px;\n\n                &:last-child {\n                    margin-right: 0;\n                }\n\n                h6 {\n                    font-size: 12px;\n                }\n\n                p {\n                    font-size: 10px;\n                }\n            }\n\n            .status-list .list-inline-item {\n                padding: 0.45rem;\n                border-right: 1px solid #dee2e6;\n\n                p.title {\n                    font-size: 13px;\n                    line-height: 14px !important;\n                    height: 27px;\n                }\n\n                &:last-child {\n                    border-right: 0;\n                }\n            }\n        }\n\n        .card-body {\n            overflow: hidden;\n\n            .totalExams-tabs {\n                background: #ffffff;\n                border: 1px solid #D8D8D8;\n                border-radius: 6px;\n\n                .nav-pills .nav-item .nav-link {\n                    color: #A2A2B1;\n                    border-radius: 0.25rem;\n                    padding: 0.25rem 0.75rem;\n                    transition: ease-in all 0.2s;\n\n                    &.active,\n                    &:hover {\n                        border-radius: 30px;\n                        color: #fff;\n                        background-color: #FEAF55;\n                    }\n                }\n\n                .btn-lightblue {\n                    border-radius: 6px;\n                    font-size: 13px;\n                    padding: 0.45rem 0.75rem;\n                }\n\n                .tab-content {\n                    .table {\n                        thead {\n                            border-bottom: 1px solid #D8D8D8;\n                        }\n\n                        tbody td {\n                            padding: 5px 6px;\n                        }\n\n                        tbody tr:nth-child(1) td {\n                            color: #00C596;\n                        }\n\n                        tbody tr:nth-child(5) td {\n                            color: #f50049;\n                        }\n\n                        .btn-lightblue {\n                            border-radius: 25px;\n                            font-size: 13px;\n                            padding: 0.25rem 0.75rem;\n                            margin-bottom: 0;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .conduct-exams {\n        .table {\n            thead th {\n                text-align: center;\n                vertical-align: middle;\n                border-bottom: 1px solid #dee2e6;\n\n                .types {\n                    p {\n                        font-weight: 400;\n                        padding: 6px;\n                        color: #ced4da;\n                    }\n\n                    p:nth-child(1) {\n                        text-align: right;\n                    }\n\n                    hr {\n                        margin: 0;\n                        transform: rotate(20deg);\n                    }\n                }\n            }\n\n            thead th:first-child {\n                padding: 0;\n                text-align: left;\n            }\n\n            thead th:first-child,\n            tbody td:first-child {\n                border-right: 1px solid #D8D8D8;\n            }\n\n            tbody td {\n                text-align: center;\n                vertical-align: middle;\n                padding: 1rem .65rem;\n\n                .count {\n                    span {\n                        color: #F05D70;\n                        position: relative;\n                        width: 25px;\n                        height: 25px;\n                        font-size: 12px;\n                        text-align: center;\n\n                        &::before {\n                            content: '';\n                            position: absolute;\n                            width: 22px;\n                            height: 22px;\n                            border: 1px solid #F05D70;\n                            border-radius: 50%;\n                            left: -6px;\n                            top: -4px;\n                        }\n                    }\n                }\n\n                i {\n                    color: #00C596;\n                    font-size: 1.4rem;\n                }\n            }\n\n            tbody tr td:first-child {\n                text-align: center;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
